// Vendor
import Highcharts from 'highcharts';
import { ElementRef, Renderer2, SimpleChanges } from '@angular/core';
import isEmpty from 'lodash.isempty';
// Constants
import { HIGHCHARTS_BAR_CHART_DEFAULT_OPTIONS, NO_DATA_CLASS, NO_DATA_DEFAULT_MESSAGE } from './constants';
import * as i0 from "@angular/core";
export class BarChartComponent {
    constructor(eltRef, renderer) {
        this.eltRef = eltRef;
        this.renderer = renderer;
        this.chartData = [];
        this.chartOptions = {};
        this.highchartOptions = { ...HIGHCHARTS_BAR_CHART_DEFAULT_OPTIONS, ...this.chartOptions };
        this.renderElement = this.eltRef.nativeElement.parentElement;
    }
    ngOnChanges(changes) {
        if (changes.chartData?.currentValue) {
            this.renderChart();
        }
    }
    renderChart() {
        // Clear chart if one has already been rendered
        this.renderElement.innerHTML = '';
        if (isEmpty(this.chartData)) {
            this.displayNoData();
            return;
        }
        this.highchartOptions.series = this.chartData;
        new Highcharts.Chart(this.renderElement, this.highchartOptions); // eslint-disable-line no-new
    }
    displayNoData() {
        const noDataMessage = document.createElement('div');
        noDataMessage.className = NO_DATA_CLASS;
        noDataMessage.innerHTML = NO_DATA_DEFAULT_MESSAGE;
        this.renderElement.append(noDataMessage);
    }
}
BarChartComponent.ɵfac = function BarChartComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BarChartComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2)); };
BarChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BarChartComponent, selectors: [["ycn-bar-chart"]], inputs: { chartData: "chartData", chartOptions: "chartOptions" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 0, vars: 0, template: function BarChartComponent_Template(rf, ctx) { }, encapsulation: 2 });
